import { css } from '@/styled-system/css';

export const systemMessageBubbleStyles = css.raw({
  borderBottomLeftRadius: '100',
  backgroundColor: 'bg.neutral',
  border: '1px solid',
  borderColor: 'border.muted',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxWidth: 448px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
  maxWidth: '448px',
  padding: 0,
});
